export const EXPIRATION_IN_DAYS = 30;



// WEBPACK FOOTER //
// ./notifications/constants.js